import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getTestIdByParts } from 'utils/getTestIdByParts';
import type { Noop, WithTestId } from 'types/app';

import { Icons } from '@Atomic/atoms/Icons';

import styles from './birBirDeliveryBanner.module.scss';

type DeliveryBannerProps = WithTestId & {
  label: string;
  badge?: string;
  onClick: Noop;
};

export const BirBirDeliveryBanner: FC<DeliveryBannerProps> = ({
  label,
  testId,
  badge,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      role="button"
      className={styles.deliveryBanner}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onClick}
      data-testid={getTestIdByParts(testId, 'birbir')}
    >
      <div className={styles.label}>{label}</div>
      <div className={styles.badge}>{badge || t('badge.inTwoHours')}</div>
      <div className={styles.button}>
        <Icons.ChevronRight width={16} height={16} />
      </div>
    </div>
  );
};
